import React from 'react';
import * as _ from 'lodash';

import { RAPIDA_FACE_IMAGE_RANGE_RESOLUTION } from '@bld/bld-libs/constants';
import { compressImage } from '@bld/bld-libs/utils';

import dialogLoader from '../../../utilities/dialogLoader';
import { ImageUploadDialog } from '../../ImageUploadDialog';
import { FormListSubNumberHeader } from '../../CommonFormComponents';
import { FileUpload } from '../../image/FileUpload';

import { isNullOrEmpty } from '../../../utilities/stringUtil';
import { messageUtility } from '../../../utilities/messageUtility';

import {
  FACE_PICTURE_UPLOAD_STATUS,
  IMAGE_DESCRIPTION_OF_TITLE,
} from '../../../utilities/constants';

/**
 * 現場常駐社員・非常駐入退場者編集 画面 > 顔写真
 */
export const SpotWorkerImageForm = ({
  events,
  workerImage,
  showEditButton,
  showDeleteButton,
}) => {
  const GuideLineText = () => {
    return (
      <div className='guide'>
        <p className='guide__text'>{messageUtility.getMessage('I-001-505')}</p>
      </div>
    );
  };

  return (
    <div className='contruction-detail-view__main'>
      <div className='WorkerImageForm SpotWorkerImageForm'>
        <div className='WorkerImageForm__image-file-upload'>
          <FileUpload
            showEditButton={showEditButton}
            showDeleteButton={showDeleteButton}
            imageUrl={workerImage.imageUrl}
            alt=''
            acceptType={data.acceptType}
            tooltipText={messageUtility.getMessage('I-000-201-01')}
            onFileUpDate={async (
              isValidSize,
              isValidType,
              isValidRangeResolution,
              fileName,
              imageBlob,
              callback
            ) => {
              let errorMessage = null;
              let title = '';
              events.setValueWorkerImage({ isInitFile: true });
              if (isNullOrEmpty(errorMessage) && !isValidSize) {
                errorMessage = messageUtility.getMessage('E-000-201-01');
              } else if (isNullOrEmpty(errorMessage) && !isValidType) {
                errorMessage = messageUtility.getMessage('E-000-201-02');
              } else if (
                isNullOrEmpty(errorMessage) &&
                !isValidRangeResolution
              ) {
                title = callback
                  ? '画像の切り抜きができません'
                  : '選択したファイルは使用できません';
                errorMessage = callback
                  ? messageUtility.getMessage('E-000-201-04')
                  : messageUtility.getMessage('E-000-201-03');
              }

              if (!isNullOrEmpty(errorMessage)) {
                events.setValueWorkerImage({
                  imageUrl: null,
                  imageBinary: null,
                  imageName: null,
                  uploadStatus: FACE_PICTURE_UPLOAD_STATUS.uploadFailed.id,
                });

                dialogLoader.show(ImageUploadDialog, {
                  onClose: () => {
                    dialogLoader.close();
                  },
                  title,
                  message: errorMessage,
                });
                callback && callback(true);
                return;
              }

              await new Promise(() => {
                callback && callback(false);
                compressImage(
                  imageBlob,
                  result => {
                    events.setValueWorkerImage({
                      imageUrl: URL.createObjectURL(result),
                      imageBinary: result,
                      imageName: fileName,
                      uploadStatus: FACE_PICTURE_UPLOAD_STATUS.uploadSuccess.id,
                      isInitFile: false,
                    });
                  },
                  RAPIDA_FACE_IMAGE_RANGE_RESOLUTION.maxSize,
                );
              });
            }}
            onFileDelete={() => {
              events.setValueWorkerImage({
                imageUrl: '',
                imageBinary: '',
                imageName: '',
                uploadStatus: FACE_PICTURE_UPLOAD_STATUS.deleteFile.id,
                isInitFile: false,
              });
            }}
            isWorkerEdit={true}
          />
        </div>
        {_.map(IMAGE_DESCRIPTION_OF_TITLE, it => {
          if (it.ID !== IMAGE_DESCRIPTION_OF_TITLE.BASIC_REGISTER.ID) {
            return (
              <React.Fragment key={it.ID}>
                <FormListSubNumberHeader
                  number={it.TITLE_NUMBER}
                  title={it.TITLE}
                  titleInfo={it.INFO}
                />
                {it.ID !==
                IMAGE_DESCRIPTION_OF_TITLE.IMPORTANT_DESCRIPTION.ID ? (
                  <img className='image-manual' src={it.IMAGE_SRC} alt='' />
                ) : (
                  <GuideLineText />
                )}
              </React.Fragment>
            );
          }
        })}
      </div>
    </div>
  );
};

// 定数
const data = {
  title: {
    section: '顔写真',
    approve: '了解',
  },
  acceptType: 'image/jpeg',
};



// WEBPACK FOOTER //
// ./src/components/spotWorker/form/SpotWorkerImageForm.jsx